<template>
  <div>
    <ModalCover @closeModal="$emit('closeTriggered')">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body">
        <div
          class="delete-modal d-flex flex-column justify-content-start align-items-center"
        >
          <!-- DELETE CAN IMAGE -->
          <img v-lazy="localImg('success-modal.png')" alt />

          <!-- TITLE -->
          <div
            class="title color_text font-weight-900 text-center text-capitalize"
          >
            {{ message }}
          </div>

          <!-- ACTION BUTTONS -->
          <div class="d-flex justify-content-center align-items-center nowrap">
            <button
              class="btn btn-md btn-primary-outline"
              @click="$emit('closeTriggered')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "RemidialSuccessModal",
  props: {
    title: String,
    message: {
      type: String,
      default: "Remidial has been added.",
    },
  },

  components: {
    ModalCover,
  },

  data() {
    return {
      account_type: null,
      return_link: "",
    };
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      if (this.account_type === "school") {
        this.return_link = "ClassHomework";
      } else if (this.account_type === "teacher") {
        this.return_link = "TeacherHomework";
      }
    },
  },
};
</script>

<style lang="scss">
.delete-modal {
  margin: 50px 70px;

  @include breakpoint_max(sm) {
    margin: 40px 55px 35px;
  }

  img {
    @include equal_min_edge(130);

    @include breakpoint_max(sm) {
      @include equal_min_edge(100);
    }
  }

  .title {
    margin-bottom: 20px;
    margin-top: 24px;
    font-size: 21px;
    line-height: 29px;

    @include breakpoint_max(sm) {
      font-size: 13.5px;
    }
  }

  .btn {
    @include breakpoint_max(sm) {
      font-size: 11px;
      padding: 9px 25px !important;
    }
  }
}
</style>
